import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { UiIconComponent } from '../icon/ui-icon.component';

/**
 * A square icon-only control. Same attribute-on-the-host approach as
 * `ui-button` so `routerLink`, `disabled` and `(click)` behave natively.
 *
 *   <button ui-icon-button icon="i-edit" [attr.aria-label]="'COMMON.EDIT' | translate"></button>
 *
 * `aria-label` is the CALLER's job — an icon-only control with no accessible
 * name is a defect the kit cannot fix for you.
 */
@Component({
  selector: 'button[ui-icon-button], a[ui-icon-button]',
  standalone: true,
  imports: [UiIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-icon-button.component.html',
})
export class UiIconButtonComponent {
  @Input({ required: true }) icon!: string;
  @Input() iconSize: number | string = 16;
  @Input() flip = false;
  @Input() size: 'md' | 'sm' = 'md';
  @Input() bordered = false;
  @Input() tone: 'default' | 'danger' = 'default';

  @HostBinding('class.ui-icon-btn') readonly base = true;
  @HostBinding('class.ui-icon-btn--sm') get isSm() { return this.size === 'sm'; }
  @HostBinding('class.ui-icon-btn--bordered') get isBordered() { return this.bordered; }
  @HostBinding('class.ui-icon-btn--danger') get isDanger() { return this.tone === 'danger'; }
}
